import React, { } from "react";
import "./HeadBlock.scss";

const HeadBlock = ({ className = '', showFolder }) => {
	return (
		<>
			<div className={`head-blc text-center ${className}`}>
				<div className="icon">
					{showFolder ? <img className="img-gif img-fluid" src={require('./../../../assets/img/icons/file-animation.gif')} alt="Folder" /> : <img className="img-icon img-fluid" src={require('./../../../assets/img/icons/folder.svg')} alt="Folder" />}
				</div>
				<label className={showFolder ? 'hidden' : ''}>Drag your documents to start uploading.</label>
			</div>
		</>
	)
};
export default HeadBlock;